import React from "react";
import { useFormContext } from "react-hook-form";
import { SubmissionsBuilderFormDataStructure } from "../types";
import FieldsList from "./FieldsList";
import ModulesList from "./ModulesList";

export const FieldsTab = () => {
  const {
    formState: { defaultValues },
  } = useFormContext<SubmissionsBuilderFormDataStructure>();

  return (
    <>
      <FieldsList />
      {!defaultValues?.inputs?.length && <ModulesList />}
    </>
  );
};
